import { render } from "./Signup.vue?vue&type=template&id=b9abc8f0"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=b9abc8f0&lang=css"
script.render = render

export default script